export default "__VITE_ASSET__D$L39YvU__"